import { GRADIENT, textStyles } from '@cosuno/cosuno-ui';
import styled from 'styled-components';

export const Title = styled.span`
  background: ${GRADIENT.gradientAi};
  background-clip: text;
  -webkit-text-fill-color: transparent;
  ${textStyles.labelMedium500};
`;
